var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8934 40.147L11.4287 34.2206L4.54483 32.8073L5.31983 26.1058L0.943359 21L5.31983 15.9397L4.54483 9.2382L11.4287 7.82496L14.8934 1.85291L21.0022 4.67938L27.111 1.85291L30.6213 7.82496L37.4595 9.2382L36.6845 15.9397L41.061 21L36.6845 26.1058L37.4595 32.8073L30.6213 34.2206L27.111 40.147L21.0022 37.3206L14.8934 40.147ZM16.1242 36.5456L21.0022 34.4941L26.0169 36.5456L29.0713 31.9867L34.4051 30.6191L33.8581 25.1941L37.5507 21L33.8581 16.7147L34.4051 11.2897L29.0713 10.0132L25.9257 5.45438L21.0022 7.50585L15.9875 5.45438L12.9331 10.0132L7.59924 11.2897L8.1463 16.7147L4.45365 21L8.1463 25.1941L7.59924 30.7103L12.9331 31.9867L16.1242 36.5456ZM19.0419 27.0632L29.3904 16.8058L27.3389 14.9367L19.0419 23.1426L14.711 18.6294L12.6139 20.6808L19.0419 27.0632Z",
    fill: "#168404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.eb1b5ff8cdea8accb2f68824a37f8fea.svg";
export { ForwardRef as ReactComponent };